export default defineNuxtPlugin(async () => {
    const { me } = useAuth();
    await me();

    // Видимость магазина задаётся в админке. Читаем её при SSR: значение
    // попадает в payload, и на клиенте лишнего запроса не будет.
    const shopConfig = useShopConfig();
    if (import.meta.server) {
        try {
            shopConfig.value = await $fetch("/api/shop/config");
        } catch {
            // Настройки недоступны — остаёмся на закрытой витрине
        }
    }

    // Корзину подтягиваем после авторизации: до неё useShopAccess ещё не знает роли
    const { refresh } = useCart();
    await refresh();
})
